import { useContext, useState } from "react";
import { Locales } from "@/app/lang/types";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";
import { twCn } from "@/styles/utils";

export const LangSwitcher = () => {
  const { lang, setLang } = useContext(ReactContext);

  const [translateValue, setTranslateValue] = useState<0 | 100>(() => {
    if (lang === Locales.Kz) {
      return 0;
    }
    return 100;
  });

  const onClick = () => {
    setTranslateValue((prev) => {
      if (prev === 0) {
        return 100;
      }
      return 0;
    });
    setLang();
  };

  return (
    <div className="bg-light-gray relative flex items-center rounded-sm">
      <div className="absolute top-0 right-0 bottom-0 left-0 z-1 overflow-hidden rounded-sm">
        <div
          style={{ transform: `translateX(${translateValue}%)` }}
          className="bg-brand absolute h-full w-[50%] rounded-sm transition-all"
        />
      </div>
      <button
        type="button"
        className="relative z-2 w-[51px] px-3 py-2"
        onClick={onClick}
      >
        <span
          className={twCn(
            translateValue === 0
              ? "text-light font-medium"
              : "text-gray font-light",
          )}
        >
          қаз
        </span>
      </button>
      <button
        type="button"
        className="relative z-2 w-[51px] px-3 py-2"
        onClick={onClick}
      >
        <span
          className={twCn(
            translateValue === 0
              ? "text-gray font-light"
              : "text-light font-medium",
          )}
        >
          рус
        </span>
      </button>
    </div>
  );
};
